import loadable from '@loadable/component';
import ModalStickyBottom from '../../components/modal-sticky-bottom/ModalStickyBottom';
import { useUser } from '../useUser';
import styles from './update-contact-info.module.less';

const UpdateContactInfoContent = loadable(() => import('./UpdateContactInfoContent'));

const UpdateContactInfo = () => {
    const user = useUser();

    const canShow = user?.id && !user?.isLoggedInAsAdmin;
    const { shouldAskForUpdatedContactDetails } = user;

    const isOpen = canShow && shouldAskForUpdatedContactDetails;

    return (
        <ModalStickyBottom isOpen={isOpen} className={styles.modal}>
            <div className={styles.container}>{isOpen && <UpdateContactInfoContent />}</div>
        </ModalStickyBottom>
    );
};

export default UpdateContactInfo;
